import classNames from 'classnames';
import {forEach} from 'lodash';
import * as React from 'react';

import styles from './ProgressTick.less';
import {PromiseUtils} from 'src/js/common/utils/promise_utils';

interface IconState {
  visible?: boolean;
  iconClass: string;
  prevProgressCounter?: number;
}

interface OwnProps {
  iconSize?: number;
  progressCounter: number;
  progressFinishedTime?: number;
}

type Props = OwnProps;

class ProgressTick extends React.PureComponent<Props> {
  static displayName = 'ProgressTick';

  constructor(props) {
    super(props);
    this.resetVisible = this.resetVisible.bind(this);

    this.state = {
      visible: false,
      iconClass: '',
    };

    this.cancelablePromises = [];
  }

  static getDerivedStateFromProps(props, state) {
    // Return null to indicate no change to state.
    let resultState: IconState | null = null;
    if (state.prevProgressCounter < props.progressCounter) {
      resultState = {
        visible: true,
        iconClass: 'fas fa-spinner fa-pulse',
        prevProgressCounter: props.progressCounter,
      };
    } else if (state.prevProgressCounter > props.progressCounter) {
      resultState = {
        iconClass: 'fas fa-check',
        prevProgressCounter: props.progressCounter,
      };
    }

    return resultState;
  }

  componentDidUpdate(prevProps) {
    const {progressCounter, progressFinishedTime = 2000} = this.props;
    if (prevProps.progressCounter > progressCounter) {
      const setTimeoutPromise = PromiseUtils.makeCancelable(
        new Promise((resolve) => {
          setTimeout(resolve, progressFinishedTime);
        })
      );
      this.cancelablePromises.push(setTimeoutPromise);
      setTimeoutPromise.promise
        .then(() => {
          // this runs only on mounted component
          this.resetVisible();
        })
        .catch(PromiseUtils.handleCanceledPromise);
    }
  }

  componentWillUnmount() {
    forEach(this.cancelablePromises, (cancelablePromise) => {
      cancelablePromise.cancel();
    });
  }

  resetVisible() {
    const {progressCounter} = this.props;
    if (progressCounter === 0) {
      this.setState({visible: false});
    }
  }

  render() {
    const {children, iconSize = 1} = this.props;
    const {iconClass, visible} = this.state;
    return (
      <span className={styles.dlProgressTick}>
        <span className={styles.dlProgressTickChild}>
          {visible ? (
            <span
              className={classNames({
                [styles.dlProgressTickIcon]: true,
                [`fa-${iconSize}x`]: true,
              })}
            >
              <i className={iconClass} />
            </span>
          ) : (
            children
          )}
        </span>
      </span>
    );
  }
}

export default ProgressTick;
